module.exports = __webpack_public_path__ + "static/media/telcard1.3f48554a.jpg";